<template>
  <div class="wrapper">
    <div class="bg" v-if="newpop">
      <div class="popup">
        <div class="area">
          <div>비디오 강의</div>
          <div class="subtitle">유투브, 트위치등을 활용한 실시간 강의 만들기</div>
        </div>
        <div class="area">
          <div>퀴즈</div>
          <div class="subtitle">토픽에 맞는 맞춤형 퀴즈 생성하기</div>
        </div>
        <div iv class="area" @click="pds">
          <div>자료</div>
          <div class="subtitle">학습자에게 제공될 자료등록</div>
        </div>
        <div class="area">
          <div>학습목표</div>
          <div class="subtitle">학습 수행 목표 및 평가기준등 제시</div>
        </div>
      </div>
    </div>
    <div class="editor">
      <Jimun />
      <editor-menu-bubble
        :editor="editor"
        :keep-in-bounds="keepInBounds"
        v-slot="{ commands, isActive, menu }"
      >
        <div
          class="menububble"
          :class="{ 'is-active': menu.isActive }"
          :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
        >
          <button
            class="menububble__button"
            :class="{ 'is-active': isActive.bold() }"
            @click="commands.bold"
          >B</button>

          <button
            class="menububble__button"
            :class="{ 'is-active': isActive.italic() }"
            @click="commands.italic"
          >I</button>

          <button
            class="menububble__button"
            :class="{ 'is-active': isActive.code() }"
            @click="commands.code"
          >C</button>
        </div>
      </editor-menu-bubble>

      <editor-floating-menu :editor="editor" v-slot="{ commands, isActive, menu }">
        <div
          class="editor__floating-menu"
          :class="{ 'is-active': menu.isActive }"
          :style="`top: ${menu.top}px`"
        >
          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 1 }) }"
            @click="commands.rd({ level: 1 })"
          >주제</button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 2 }) }"
            @click="commands.heading({ level: 2 })"
          >영상</button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 3 }) }"
            @click="commands.heading({ level: 3 })"
          >이미지</button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.bullet_list() }"
            @click="commands.bullet_list"
          >퀴즈</button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.ordered_list() }"
            @click="commands.ordered_list"
          >목록</button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.blockquote() }"
            @click="commands.blockquote"
          >사전</button>

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.code_block() }"
            @click="commands.code_block"
          >박스</button>
        </div>
      </editor-floating-menu>
      <editor-content class="editor__content" :editor="editor" />
    </div>
  </div>
</template>

<script>
import {
  Editor,
  EditorContent,
  EditorMenuBar,
  EditorMenuBubble,
  EditorFloatingMenu,
} from "tiptap";

import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Placeholder,
} from "tiptap-extensions";

import Doc from "./Doc";
import Title from "./Title";
import RedHeading from "./RedHeading";

import Jimun from "@/components/Jimun";

export default {
  props: ["contentid", "m"],
  components: {
    EditorContent,
    EditorMenuBubble,

    EditorFloatingMenu,
    Jimun,
  },
  watch: {
    contentid: {
      immediate: true,
      handler(val, old) {
        if (val != null) {
          this.$store.dispatch("pullContent", val);
        } else {
          this.processNew();
        }
      },
    },
    m: {
      immediate: true,
      handler(val, old) {
        if (val === "new") {
          this.newpop = true;
        } else {
          this.newpop = false;
        }
      },
    },

    article: {
      immediate: true,
      handler(val, old) {
        console.log("_changed");
        this.editor.setContent(val + "");
      },
    },
  },
  created() {
    console.log("created");
    console.log(this.contentid);
  },
  computed: {
    article() {
      return this.$store.state.content.Article;
    },
  },
  data() {
    return {
      keepInBounds: true,
      newpop: false,
      editor: new Editor({
        autoFocus: true,
        editable: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new RedHeading(),
          new Doc(),
          new Title(),
          new Placeholder({
            emptyNodeClass: "is-empty",
            color: "#e76f51",
            showOnlyCurrent: false,
            emptyNodeText: (node) => {
              if (node.type.name === "title") {
                return "Give  me a message";
              }
              return " ";
            },
          }),
        ],
        content: "",
      }),
      editable: false,
    };
  },
  methods: {
    processNew() {
      // alert("processNew");
      // pick the template for generating content
    },
    pds() {
      this.m = "old";
      this.editor.editable = true;
    },
  },
  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>


<style lang="scss">
@import "@/styles/_variables.scss";
.wrapper {
  padding: 10px;
}
.bg .popup {
  width: 800px;
  height: 600px;
  background-color: $gray50;
  border-radius: 8px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  .area {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    font-size: 1.2em;
    font-family: $font;
    font-weight: 700;
    color: $gray50;
    .subtitle {
      font-size: 0.8em;
      font-weight: 200;
    }
  }
  .area:hover {
    opacity: 0.8;
  }
  .area:nth-child(1) {
    background-color: $color5;
  }
  .area:nth-child(2) {
    background-color: $color2;
  }
  .area:nth-child(3) {
    background-color: $point1;
  }
  .area:nth-child(4) {
    background-color: $color6;
  }
}

.editor {
  position: relative;
  &__floating-menu {
    position: absolute;
    z-index: 1;
    margin-top: -0.25rem;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
    &.is-active {
      opacity: 1;
      visibility: visible;
    }
  }
  .rdclass {
    // color: red;
    // border-bottom: 1px solid red;
    background: #ddd;
    border-radius: 4px;
    padding: 6px;
    font-size: 1em;
    font-weight: normal;
    margin-bottom: 1px;
  }
}

.editor__content *.is-empty:nth-child(1)::before,
.editor__content *.is-empty:nth-child(2)::before {
  content: attr(data-empty-text);
  float: left;
  color: #c9cdd2;
  pointer-events: none;
  height: 0;
  font-style: italic;
}
</style>